import radioActive from "../../assets/images/radio_active.svg";
import radioUnactive from "../../assets/images/radio_unactive.svg";

/**
 * The selectable option card in the file-a-claim wizard (customer type, policy
 * type, plan, repair-or-cash).
 *
 * The card used to carry `transition-all` and nothing else: no press feedback,
 * and the radio changed by swapping one <img> src for another, so the first
 * selection on a page flickered while the second file loaded. Both marks are
 * rendered now and crossfaded, and the transition names the properties it
 * actually animates.
 */
const MotorPolicyOptionsCard = ({
  label = "",
  title,
  description,
  isSelected,
  onSelect,
}) => {
  return (
    <div
      onClick={onSelect}
      className={`gap-4 p-6 rounded-[10px] border-solid border mb-4 cursor-pointer w-full optioncard box-border select-none touch-manipulation
        transition-[background-color,border-color,transform] duration-200 ease-out
        active:scale-[0.985] active:duration-100 ${
        isSelected
          ? "bg-[#E3F8FF] border-[#00719A] border-2 box-border "
          : "bg-white border-transparent border-2 box-border outline-1 outline-[#DDE2E4] hover:bg-[#F7FAFB]"
      }`}
    >
      <div className="items-center gap-4 grid box-border">
        <input
          type="radio"
          checked={isSelected}
          onChange={onSelect}
          className="mr-3 mb-4 hidden"
        />
        {/* Both marks stay mounted and crossfade. Swapping the src meant the
            active SVG was fetched at the moment of the tap — a blank frame on
            the very interaction that needs to feel immediate. */}
        <span className="relative block w-6 h-6 shrink-0">
          <img
            src={radioUnactive}
            alt=""
            aria-hidden="true"
            className={`absolute inset-0 w-6 h-6 transition-opacity duration-150 ease-out ${
              isSelected ? "opacity-0" : "opacity-100"
            }`}
          />
          <img
            src={radioActive}
            alt=""
            aria-hidden="true"
            className={`absolute inset-0 w-6 h-6 transition-[opacity,transform] duration-150 ease-out ${
              isSelected ? "opacity-100 scale-100" : "opacity-0 scale-90"
            }`}
          />
          <span className="sr-only">
            {isSelected ? "Selected" : "Not Selected"}
          </span>
        </span>
        <div className="flex-col">
          <h2 className="font-medium text-lg label">{label}</h2>
          <h2 className="font-medium text-lg title">{title}</h2>
          <p className="text-[#48535B] text-base not-italic font-normal leading-6 tracking-[-0.16px] description">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MotorPolicyOptionsCard;
